import React, { useState } from "react";
import styles from "./index.module.css";
import backArrow from "../../../assets/wall-icons/back_arrow.png";

const index = ({ onClose, onConfirm }) => {
    const [title, setTitle] = useState("");

    const handleChange = (e) => {
        setTitle(e.target.value);
    };
    return (
        <div className={styles.fixedOverlay} onClick={onClose}>
            <div
                className={styles.addSectionContainer}
                onClick={(e) => {
                    e.stopPropagation();
                }}
            >
                <div className={styles.headingContainer}>
                    <img className={styles.backButton} src={backArrow} onClick={onClose} />
                    <div className={styles.title}>Section Name</div>
                </div>
                <input className={styles.textInput} placeholder={"Name of section"} value={title} onChange={handleChange} />
                <button
                    className={styles.confirmButton}
                    onClick={() => {
                        onConfirm(title);
                    }}
                >
                    Confirm
                </button>
            </div>
        </div>
    );
};

export default index;
